import { INTERCOM_SHOW_MESSAGES, INTERCOM_SHOW_HELP_CENTER } from './analyticsConstants';

export const intercomShowMessages = () => ({ type: INTERCOM_SHOW_MESSAGES });
export const intercomShowHelpCenter = () => ({ type: INTERCOM_SHOW_HELP_CENTER });
